enum PackageStatus {
  Draft = 'D',
  Published = 'P',
  Retired = 'C',
}

export default PackageStatus;
